import HomeSectionCtrl from './HomeSectionCtrl';
import homeHtml from './home.html';
import './header.css';
let homeSection = () => {
    return {
        restrict: 'E',
        templateUrl: homeHtml,
        controller: 'HomeSectionCtrl',
        controllerAs: 'HomeSection',
        replace: true
    }
};

export default angular.module('App.Home', [])
    .directive('homeSection', homeSection)
    .controller('HomeSectionCtrl', HomeSectionCtrl);


// WEBPACK FOOTER //
// ./src/app/modules/home/index.js